import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../../../../../environments/environment';
import {SafePipe} from '../../../../common/pipes/safe.pipe';
import {SafeResourceUrl} from '@angular/platform-browser';
import {SafeStringType} from 'src/app/modules/clm/types/safe-string-type.enum';

@Component({
  selector: 'app-rules-engine-view',
  templateUrl: './rules-engine-view.component.html',
  styleUrls: [],
  providers: [SafePipe]
})
export class RulesEngineViewComponent implements OnInit {

  url: SafeResourceUrl;
  private baseEngineUrl = environment.baseEngineUrl;
  private baseAuthorUrl = environment.baseAuthorUrl;

  constructor(
    private route: ActivatedRoute,
    private safePipe: SafePipe
  ) {}

  ngOnInit(): void {
    if (this.route.snapshot.url[0].path.includes('author')) {
      this.url = this.safePipe.transform(this.baseAuthorUrl + '/author/', SafeStringType.ResourceUrl);
    }
    else if (this.route.snapshot.url[0].path.includes('engine')) {
      this.url = this.safePipe.transform(this.baseEngineUrl + '/engine/', SafeStringType.ResourceUrl);
    }
  }

}
